import { createAsyncCategoryHandler } from "../category-dispatcher";
import { screenManagementTools } from "./screen-management-tools";
import { screenSettingsTools } from "./screen-settings-tools";
import { screenTools } from "./screen-tools";

/**
 * Category handler for screen-level operations.
 * Consolidates screen-tools, screen-management-tools, and screen-settings-tools
 * handlers for listing, inspecting, navigating, creating, deleting, renaming,
 * duplicating screens, managing screen folders, and screen-level settings
 * (press-enter, shortcuts, offline, pull-to-refresh).
 */
export const handleScreenCategory = createAsyncCategoryHandler(
  {
    list: screenTools.sync!.ui_common_list_screens,
    get_current: screenTools.sync!.ui_common_get_current_screen,
    create_folder: screenTools.sync!.ui_project_create_screen_folder,
    move_to_folder: screenTools.sync!.ui_project_move_screen_to_folder,
    get_press_enter_button: screenSettingsTools.sync!.ui_screen_get_press_enter_button,
    set_press_enter_button: screenSettingsTools.sync!.ui_screen_set_press_enter_button,
    list_shortcuts: screenSettingsTools.sync!.ui_screen_list_shortcuts,
    add_shortcut: screenSettingsTools.sync!.ui_screen_add_shortcut,
    update_shortcut: screenSettingsTools.sync!.ui_screen_update_shortcut,
    delete_shortcut: screenSettingsTools.sync!.ui_screen_delete_shortcut,
    set_offline: screenSettingsTools.sync!.ui_screen_set_offline,
    set_pull_to_refresh: screenSettingsTools.sync!.ui_screen_set_pull_to_refresh,
    get_layout_positions: screenSettingsTools.sync!.ui_screen_get_layout_positions,
    set_layout_positions: screenSettingsTools.sync!.ui_screen_set_layout_positions
  },
  {
    navigate: screenTools.async!.ui_project_navigate_to_screen,
    create: screenManagementTools.async!.ui_project_create_screen,
    delete: screenTools.async!.ui_project_delete_screen,
    rename: screenTools.async!.ui_project_rename_screen,
    duplicate: screenTools.async!.ui_project_duplicate_screen,
    create_master: screenManagementTools.async!.ui_project_create_master_screen,
    set_master_screen: screenManagementTools.async!.ui_screen_set_master_screen
  }
);
